<div class="p-2">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
        [data]="ignoredTimesheetSummaryData" [disableSelection]="true" [cols]="cols" [gridTitle]="false"
        [pagination]="true" [rowsToDisplay]="20" [loadPage]="true" [enableActions]="false" [customDataLoaded]="true"
        [tableScrollable]="true">
    </ppl-list-table>
</div>